import { Alert, useAlert } from '@apex/component-library'
import { useToast } from '@chakra-ui/react'
import axios, { AxiosError, AxiosResponse } from 'axios'
import React, { useCallback } from 'react'
import { useEffect } from 'react'

const watchedUrls = [/\/scheduled-transfers\/api\/v1\/schedules\/.*/]

const isWatchedUrl = (requestURL: string | undefined) => {
  if (!requestURL) {
    return false
  }
  return watchedUrls.some((watchedUrl) => watchedUrl.test(requestURL))
}

export default function useInterceptors() {
  const toast = useToast()
  const { setAlert } = useAlert()
  const setAlertMemo = useCallback(setAlert, [])

  useEffect(() => {
    // pass thru on success
    const responseHandler = (response: AxiosResponse) => response

    const errorHandler = (error: AxiosError) => {
      if (error.response && isWatchedUrl(error.config.url)) {
        if (error.response.status >= 400 && error.response.status < 500) {
          toast({
            position: 'top-right',
            variant: 'left-accent',
            isClosable: true,
            title: 'The request failed.',
            description: `${error.response.data.errorDescription}`,
            status: 'error',
            duration: null,
            render: ({ onClose, id }) => (
              <Alert
                sx={{
                  width: 340,
                  color: 'black',
                  bg: 'white',
                  boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
                }}
                direction='column'
                variant='left-accent'
                title='The request failed.'
                description={`${error?.response?.data.errorDescription || ''}`}
                status='error'
                isClosable
                dismiss={onClose}
                id={id as string}
              />
            )
          })
        } else {
          setAlertMemo({
            title: 'System Unavailable',
            description: 'Sorry, this service is temporarily unavailable. Please check back later.',
            status: 'error',
            direction: 'row',
            isClosable: true,
            showIcon: true
          })
        }
      }
      return Promise.reject(error)
    }
    const interceptor = axios.interceptors.response.use(responseHandler, errorHandler)

    return () => axios.interceptors.response.eject(interceptor)
  }, [toast, setAlertMemo])
}
